import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_URL } from '@core/constants';
import { IProviderResponseDTO } from '@core/model';
import { ApplicationStateService } from '@core/service/application-state.service';
import { PhysicianAccountDTO, PhysicianAccountPgpsDTO, PhysicianPgpDTO } from '@mynexus/mynexus-ui-lib';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrderingProviderService {
  constructor(
    public http: HttpClient,
    private applicationStateService: ApplicationStateService,
    @Inject(API_URL) private apiUrl: string
  ) {}

  private get baseUrl(): string {
    return `${this.apiUrl}/api/tenants/${this.applicationStateService.tenantId}`;
  }

  getPhysicianAccountPgpsByNpi(npi: string, memberId: string): Observable<PhysicianAccountPgpsDTO[]> {
    return this.http.get<PhysicianAccountPgpsDTO[]>(`${this.baseUrl}/providers/ordering/${npi}`, {
      params: { memberId }
    });
  }

  createUpdateOrderingProvider(
    authorizationByProductId: string,
    providerAccountId: string,
    providerPgpId: string
  ): Observable<IProviderResponseDTO> {
    return this.http.put<IProviderResponseDTO>(
      `${this.baseUrl}/authorizations/${authorizationByProductId}/providers/ordering`,
      { providerAccountId, providerPgpId }
    );
  }

  getProviderForAuthorization(
    authorizationByProductId: string
  ): Observable<PhysicianAccountPgpsDTO> {
    return this.http.get<{
      physicianAccountDTO: PhysicianAccountDTO;
      physicianPgpDTO: PhysicianPgpDTO
    }>(
      `${this.baseUrl}/authorizations/${authorizationByProductId}/providers/ordering`
    ).pipe(map(data => {
      return data ? {
        physicianAccountDTO: data.physicianAccountDTO,
        physicianPgpDTOList: [data.physicianPgpDTO]
      } : null
    }));
  }
}
